import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({ name: 'dateMomentFormat' })
export class DateMomentPipe implements PipeTransform {
    transform(value: Date | moment.Moment, dateFormat: string): any {

        var offset = new Date().getTimezoneOffset();
        return moment(value).add(Math.abs(offset), "minutes").format('YYYY-MM-DD HH:mm');
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/date-moment.pipe.ts